document.addEventListener("DOMContentLoaded", function() {
  let loading = false;
  const paginationSelector = ".pagination";  
  const productGridSelector = ".product-grid"; 
  const loadOffset = 300; 

  window.addEventListener("scroll", function() {
    if (loading) return;
    const pagination = document.querySelector(paginationSelector);
    if (!pagination) return;

    const rect = pagination.getBoundingClientRect();
    if (rect.top - window.innerHeight < loadOffset) {
      const nextLink = pagination.querySelector("a.next"); 
      if (nextLink) {
        loading = true;
        fetch(nextLink.href)
          .then(resp => resp.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newProducts = doc.querySelectorAll(productGridSelector + " > *");  
            const currentGrid = document.querySelector(productGridSelector);
            newProducts.forEach(p => currentGrid.appendChild(p));
            const newPagination = doc.querySelector(paginationSelector);
            if (newPagination) {
              pagination.innerHTML = newPagination.innerHTML;
            } else {
              pagination.remove();
            }
          })
          .finally(() => {
            loading = false;
          });
      }
    }
  });
});
